import { afterEvent, cardRef, defineGameCard, onAppear } from '../authoring/index.js';
export const CampaignArmorerCard = defineGameCard({
    id: 'campaign_armorer',
    gameplay: { type: 'UNIT', cost: 5, baseStats: { attack: 4, health: 6 } },
    presentation: {
        name: 'Походный оружейник',
        description: 'При раскрытии следующий ваш боец получает +1 к атаке и +2 к максимальному и текущему здоровью.',
        glyph: {
            colors: ['#10213A', '#605E5D', '#354048', '#CF6C24', '#151922'],
            rows: [
                '....................',
                '.......11...........',
                '......1231..........',
                '......123111111.....',
                '......1231444421....',
                '......1331111111....',
                '......1331..........',
                '..1111111111111111..',
                '.122223333333322221.',
                '..1133322444233311..',
                '....113244422311....',
                '......11444411......',
                '.......155551.......',
                '.......155551.......',
                '....111335533111....',
                '...12222555522221...',
                '...13335111133351...',
                '....1111....1111....',
                '....................',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('campaign_armorer')],
    abilities: [
        onAppear((ctx) => {
            if (ctx.self === undefined)
                return;
            ctx.ops.addEffect({
                defId: CampaignArmorerCard.id,
                scope: { kind: 'player', playerId: ctx.self.controllerId },
                sourceId: ctx.self.id,
                persistent: true,
                vars: { pendingAttackBonus: 1, pendingHealthBonus: 2 },
            });
        }, { cause: 'played' }),
        afterEvent({
            event: 'UnitEnteredPlay',
            run: (ctx, event) => {
                if (ctx.effect?.scope.kind !== 'player')
                    return;
                const target = ctx.q.instance(event.instanceId);
                if (target === null || target.controllerId !== ctx.effect.scope.playerId
                    || ctx.q.cardType(target.id) !== 'UNIT')
                    return;
                ctx.ops.modifyStat(target.id, 'attack', 1);
                ctx.ops.modifyStat(target.id, 'maxHealth', 2);
                ctx.ops.modifyStat(target.id, 'health', 2);
                ctx.ops.removeEffect(ctx.effect.id);
            },
        }),
    ],
});
//# sourceMappingURL=campaign_armorer.js.map